module.exports = __webpack_public_path__ + "static/media/intro-background-formula1.539e83b6.png";